// extracted by mini-css-extract-plugin
export default {"button":"WrapperButton_button__8ozfd"};